import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { RouteConfig } from './config';
import { ROUTES } from './constants';

interface GenerateRoutesProps {
  routes: RouteConfig[];
  userRole?: string;
  isAuthenticated: boolean;
}

export const generateRoutes = ({ routes, userRole, isAuthenticated }: GenerateRoutesProps): React.ReactNode[] => {
  const flattenRoutes = (routes: RouteConfig[], parentRoles?: string[]): RouteConfig[] => (
    routes.reduce<RouteConfig[]>((acc, route) => [
      ...acc,
      { ...route, roles: route.roles || parentRoles },
      ...(route.children ? flattenRoutes(route.children, route.roles || parentRoles) : [])
    ], [])
  );

  const getRouteElement = (route: RouteConfig): React.ReactNode => {
    if ((route.requireAuth || route.roles) && !isAuthenticated) {
      return <Navigate to={ROUTES.LOGIN} replace />;
    }

    if (route.roles && userRole && !route.roles.includes(userRole.toUpperCase())) {
      return <Navigate to={ROUTES.ERROR_401} replace />;
    }

    return <route.element userRole={userRole} />;
  };

  return flattenRoutes(routes).map(route => (
    <Route
      key={route.path}
      path={route.path}
      element={getRouteElement(route)}
    />
  ));
};